import { useTranslation } from 'react-i18next';

import { Select } from '@/app/components/ui/Field';

/**
 * A curated set of IANA timezones — one representative zone per UTC offset
 * region actually in use across the company's footprint, not the full ~400-
 * entry `Intl.supportedValuesOf('timeZone')` list, which would dwarf every
 * other field on this form. A value already on the record but not in this
 * list (set elsewhere, or a zone this list doesn't cover) is kept as an
 * extra option, the same pattern `PreferredLanguageSelect` uses — saving the
 * form without touching this field never changes it.
 */
// eslint-disable-next-line react-refresh/only-export-components -- shared constant, small file
export const COMMON_TIMEZONES = [
  'UTC',
  'Europe/London',
  'Europe/Amsterdam',
  'Europe/Berlin',
  'Europe/Paris',
  'Europe/Madrid',
  'Europe/Rome',
  'Europe/Warsaw',
  'Europe/Athens',
  'Europe/Helsinki',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Sao_Paulo',
  'Africa/Johannesburg',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Pacific/Auckland',
];

export function TimezoneSelect({
  id,
  value,
  onChange,
}: {
  id?: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  const hasLegacyValue = value !== '' && !COMMON_TIMEZONES.includes(value);

  return (
    <Select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
      <option value="">{t('profile.timezoneUnset')}</option>
      {COMMON_TIMEZONES.map((zone) => (
        <option key={zone} value={zone}>
          {zone}
        </option>
      ))}
      {hasLegacyValue && <option value={value}>{value}</option>}
    </Select>
  );
}
